// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__xe3UC","logoImage":"Logo_logoImage__TP1pl"};